import { Component, OnInit } from '@angular/core';
import { DropdownCard } from '../../../core/models/DigitalKit';
import { infoKitCard } from '../../../core/models/DigitalKit';

@Component({
    selector: 'app-digital-kit',
    templateUrl: './digital-kit.component.html',
    styleUrls: ['./digital-kit.component.css'],
    standalone: false
})
export class DigitalKitComponent implements OnInit {
  public dropdownCard!: DropdownCard[];
  public infoCard: infoKitCard[];
  
  constructor() {
    this.infoCard = [
      {
        icon:{
          src:"../../../assets/svg/Bill.svg",
          alt:"bill_icon"
        },
        text:"Para que te olvides de todos los tramites y puedas ahorrar tiempo, nosotros realizamos la solicitud del bono digital por ti. Para poder tramitarlo, necesitaremos un documento por vuestra parte que nos autorice a ser representantes voluntarios."
      },
      {
        icon:{
          src:"../../../assets/svg/Assessment.svg",
          alt:"assessment_icon"
        },
        text:"En Zeeker Solutions cubrimos el 100% de las soluciones digitales que incluyen el Kit Digital por lo que, te ofrecemos asesoramiento digital para definir exactamente qué herramientas necesita tu negocio y así, impulsar su crecimiento con este programa de ayudas."
      },
      {
        icon:{
          src:"../../../assets/svg/Manager.svg",
          alt:"manager_icon"
        },
        text:"¡Elige a Zeeker Solutions como tu representante voluntario! adaptaremos cada solución a tus necesidades y te daremos servicio, como mínimo, durante los 12 meses que dura el proyecto, y despues, si tu quieres podrás ampliar su duración 😉."
      },
    ],
    this.dropdownCard = [
      {
        title:"sitio web y presencia online",
        icon:{
          src:"../../../assets/svg/Web.svg",
          alt:"web_icon"
        },
        dropOne:{
          text: "En esta categoría podrás canjear un importe máximo de 2.000€, independientemente del segmento al que pertenezcas, para aumentar tu visibilidad online a través de los siguientes servicios:",
          bullet:[
            "Adquisición de un nuevo dominio para tu sitio web durante un mínimo de 12 meses.",
            "Contar con el alojamiento de tu web durante 12 meses como mínimo.",
            "Diseño de la estructura web con un mínimo de 3 apartados.",
            "Tu página web estará adaptada a un diseño web responsive.",
            "La web contará con los criterios de conformidad de nivel AA de las Pautas WCAG-2.1 para considerarse accesible.",
            "Plataforma de gestión de contenidos para que el cliente pueda modificar el contenido de forma autónoma.",
            "Configuración de un posicionamiento básico en los motores de búsqueda.",
            "SEO on-page de 2 páginas, indexación y jerarquización del contenido."
          ]
        },
        dropTwo:[
          "La solución se dotará en dos fases.",
          "La primera, 3 meses con una ejecución comprometida del 70%.",
          "La segunda fase, 12 meses con una ejecución comprometida del 30%."
        ]
      },
      {
        title:"Comercio electrónico",
        icon:{
          src:"../../../assets/svg/Ecommerce.svg",
          alt:"ecommerce_icon"
        },
        dropOne:{
          text: "En esta categoría podrás canjear un importe máximo de 2.000€, independientemente del segmento al que pertenezcas, con el que podrás crear tu ecommerce para vender tus productos o servicios, las funcionalidades son las siguientes:",
          bullet:[
            "Crear la tienda online donde tendrás a tu catálogo de productos disponibles, se podrán carga hasta un máximo 100 referencias de productos.",
            "Nosotros como agentes digitalizadores, te ayudaremos a configurar e integrar los distintos métodos de pago.",
            "El comercio electrónico estará adaptada a un diseño web responsive.",
            "La tienda online contará con los criterios de conformidad de nivel AA de las Pautas WCAG-2.1 para considerarse accesible.",
            "Tu ecommerce será indexable por los motores de búsqueda. También se realizará un análisis de competencia y palabras clave, SEO on-page de 2 páginas, jerarquización del contenido y informe de seguimiento trimestral.",
            "Tendrás una plataforma de gestión de contenidos para modificarlos cuando quieras.",
            "Tendrás configuradas e integradas las distintas formas de envío.",
          ]
        },
        dropTwo:[
          "La solución se dotará en dos fases.",
          "La primera, 3 meses con una ejecución comprometida del 70%.",
          "La segunda fase, 12 meses con una ejecución comprometida del 30%."
        ]
      },
      {
        title:"Gestión de redes sociales",
        icon:{
          src:"../../../assets/svg/SocialNetwork.svg",
          alt:"socialNetwork_icon"
        },
        dropOne:{
          text: "En esta categoría podrás canjear un importe máximo de 2.500€ si perteneces al segmento I y segmento II y, un importe máximo de 2.000€ si perteneces al segmento III. El objetivo de este bono es que la empresa beneficiaria aumente su presencia a través de las redes sociales, los servicios que se incluyen son los siguientes:",
          bullet:[
            "Zeeker Solutions, como agente digitalizador, gestionará el perfil de una red social que tú elijas.",
            "Te ayudaremos a mejorar el rendimiento de tus publicaciones y analizaremos los diferentes canales sociales.",
            "Monitorización periódica mediante diferentes métricas para comprobar si se están cumpliendo los objetivos.",
            "Podrás tener una estrategia de social media orientada a tus objetivos para que conectes con tus clientes potenciales y consigas fidelizarlos.",
            "Publicaremos un mínimo de 4-8 entradas mensuales en tu red social elegida.",
          ]
        },
        dropTwo:[
          "La solución se dotará en dos fases.",
          "La primera, 3 meses con una ejecución comprometida del 40%.",
          "La segunda fase, 12 meses con una ejecución comprometida del 60%."
        ]
      },
      {
        title:"Gestión de clientes",
        icon:{
          src:"../../../assets/svg/Clients.svg",
          alt:"clients_icon"
        },
        dropOne:{
          textArray:[
            "En esta categoría podrás canjear un importe máximo de 4.000€ para el segmento I donde se incluyen 3 usuarios y, un importe máximo de 2.000€ para los segmentos II y III donde se incluirá 1 usuario a cada uno.",
            "El objetivo de este bono es digitalizar y mejorar la gestión de las relaciones comerciales con tus clientes.",
            "Habrá una serie de horas destinadas a la parametrización para definir las necesidades de cada proceso, en el caso del segmento I, se han determinado 40 horas y, en el caso de los segmentos II y III, se han destinado 30 horas.",
            "Los servicios y funcionalidades son los siguientes:",
          ],
          bullet:[
            "Conseguirás almacenar y consultar los datos de tus clientes y, simular la compra de un producto o servicio.",
            "Podrás registrar nuevos leads manualmente o mediante un fichero importado. Además, podrás parametrizar reglas de negocio para asignarle un lead según un criterio.",
            "Gestionarás todas las oportunidades de negocio que conlleven el envío de ofertas y presupuestos al lead.",
            "Zeeker Solution te implantará la herramienta que tú elijas para crear acciones y tareas comerciales.",
            "Podrás realizar un seguimiento a través de indicadores (KPI´s), listado de oportunidades, y otros, con diferentes niveles de agregación de información en función de tus necesidades. También podrás generar informes para el seguimiento y monitorización de tu actividad comercial.",
            "Lograrás visualizar las alertas de los clientes en gráficos de diversas formas (iconos, mensajes emergentes, etc.).",
            "La solución incluye un software para gestionar de forma centralizada todos los documentos de tu actividad comercial.",
            "Contarás con una interfaz fácil de usar desde cualquier dispositivo.",
            "Tendrás APIs o Web Services para consolidar la información y datos de toda tu empresa.",
          ]
        },
        dropTwo:[
          "La solución se dotará en dos fases.",
          "La primera, 3 meses con una ejecución comprometida del 70%.",
          "La segunda fase, 12 meses con una ejecución comprometida del 30%."
        ]
      },
      {
        title:"Business intelligence y analítica",
        icon:{
          src:"../../../assets/svg/Growth.svg",
          alt:"growth_icon"
        },
        dropOne:{
          textArray:[
            "En esta categoría podrás canjear un importe máximo de 4.000€ para el segmento I donde se incluyen 3 usuarios, un importe máximo de 2.000€ para el segmento II donde se incluye 1 usuario, y un importe máximo de 1.500€ para el segmento III con 1 usuario.",
            "El objetivo de este bono es que tu empresa pueda analizar grandes cantidades de datos para tomar decisiones más coherentes.",
            "Habrá una serie de horas destinadas a la parametrización para definir las necesidades de cada proceso, en el caso del segmento I, serán 70 horas, para el segmento II, se han determinado 40 horas y, para el segmento III, 30 horas.",
            "Los servicios y funcionalidades que se incluyen son los siguientes:",
          ],
          bullet:[
            "Podrás crear paneles de datos personalizados con la información que consideres relevante para después poder visualizarlos de distintas formas.",
            "Contarás con acceso a otras bases de datos y a realizar comparaciones con los datos expuestos.",
            "Como mínimo, tendrás a tu disposición una capacidad de almacenamiento de 1 GB por usuario.",
            "Tus datos podrás ser exportados a imágenes o a documentos de Excel.",
          ],
        },
        dropTwo:[
          "La solución se dotará en dos fases.",
          "La primera, 3 meses con una ejecución comprometida del 70%.",
          "La segunda fase, 12 meses con una ejecución comprometida del 30%."
        ]
      },
      /* {
        title:"Gestión de Procesos",
        icon:{
          src:"../../../assets/svg/Process.svg",
          alt:"process_icon"
        },
        dropOne:{
          textArray:[
            "En esta categoría podrás canjear un importe máximo de 6.000€ para el segmento I con 10 usuarios, un importe máximo de 2.000€ para el segmento II con 3 usuario, y un importe máximo de 500€ para el segmento III con 1 usuario.",
            "El objetivo es que tu empresa pueda digitalizar o automatizar sus procesos operativos o productivos.",
            "Habrá una serie de horas destinadas a la parametrización para definir las necesidades de cada proceso, en el caso del segmento I, se han determinado 60 horas y, en el caso de los segmentos II y III, se han destinado 45 horas.",
            "Los servicios y funcionalidades que se incluyen son los siguientes:"
          ],
          bullet:[
            "Podrás digitalizar y/o automatiza procesos como: contabilidad y finanzas, facturación, proyectos, inventario, compras y pagos, recursos humanos y, logística).",
            "Tendrás APIs o Web Services para integrar la solución con otras herramientas.",
            "La solución es escalable por lo que si tu empresa crece, esta se adaptará a los cambios y, deberá estar actualizada con las últimas versiones.",
          ],
        },
        dropTwo:[
          "La solución se dotará en dos fases.",
          "La primera, 3 meses con una ejecución comprometida del 70%.",
          "La segunda fase, 12 meses con una ejecución comprometida del 30%."
        ]
      },
      {
        title:"Factura electrónica",
        icon:{
          src:"../../../assets/svg/ElectronicBill.svg",
          alt:"ElectronicBill_icon"
        },
        dropOne:{
          textArray:[
            "En esta categoría podrás canjear un importe máximo de 1.000€ para los segmentos I y II con 3 usuarios, y un importe máximo de 500€ para el segmento III con 1 usuario.",
            "Este bono está destinado a digitalizar todo el proceso de emisión de facturas de tus clientes.",
            "Habrá una serie de horas para la parametrización para definir las necesidades de cada proceso, en el caso de los segmentos I y II, se han determinado 10 horas y, en el caso del segmento III, se han destinado 5 horas.",
            "Los servicios y funcionalidades son los siguientes:"
          ],
          bullet:[
            "Podrás emitir facturas en distintos formatos para facilitar su tratamiento automatizado.",
            "El número de facturas emitidas serán ilimitadas.",
            "La capacidad de enviar facturas a clientes será ilimitada.",
            "La creación de productos o servicios facturables dentro del catálogo será ilimitado.",
            "La solución que implantemos en tu negocio llevará incorporada la opción de enviar facturas directamente por correo electrónico.",
            "Podrás personalizar tu factura con el logotipo de tu empresa y los colores corporativos.",
            "Copias de seguridad diarias.",
            "1GB de almacenamiento para todas tus facturas.",
            "Dispondrás de APIs o Web Services para integrarlo con otras herramientas.",
            "Controlarás el vencimiento de tus facturas."
          ],
        },
        dropTwo:[
          "La solución se dotará en dos fases.",
          "La primera, 3 meses con una ejecución comprometida del 70%.",
          "La segunda fase, 12 meses con una ejecución comprometida del 30%."
        ]
      }, */
      {
        title:"Servicios y herramientas de oficina virtual",
        icon:{
          src:"../../../assets/svg/Remote.svg",
          alt:"Remote_icon"
        },
        dropOne:{
          textArray:[
            "En esta categoría podrás canjear un importe máximo de 250€ por usuario. Si eres del segmento I podrás cajear hasta 48 usuarios, si eres del segmento II hasta 9 usuarios y si perteneces al segmento III solo podrás canjear hasta 2 usuarios.",
            "El objetivo de esta categoría es implantar soluciones interactivas y funciones que permitan una colaboración más eficiente entre tu equipo, los servicios y funcionalidades son los siguientes:",
          ],
          bullet:[
            "El proveedor te acompañará durante el proceso creativo de ideación o gestión de equipos informáticos para la gestión colaborativa de proyectos, conocimientos y/o el funcionamiento de la organización.",
            "Contarás con 1 TB de almacenamiento para tus archivos.",
            "La solución escogida será compatible con cualquier dispositivo móvil.",
            "Podrás organizar tu calendario y la tareas que tengas previstas.",
          ],
        },
        dropTwo:[
          "La solución se dotará en dos fases.",
          "La primera, 3 meses con una ejecución comprometida del 70%.",
          "La segunda fase, 12 meses con una ejecución comprometida del 30%."
        ]
      },
      {
        title:"Comunicaciones seguras",
        icon:{
          src:"../../../assets/svg/Security.svg",
          alt:"security_icon"
        },
        dropOne:{
          textArray:[
            "En esta categoría podrás canjear un importe máximo de 125€ por usuario. Si eres del segmento I podrás cajear hasta 48 usuarios, si eres del segmento II hasta 9 usuarios y si perteneces al segmento III solo podrás canjear hasta 2 usuarios.",
            "Con este bono conseguirás que las conexiones entre tus empleados sea más seguras, los servicios y funcionalidades que se incluyen son los siguientes:",
          ],
          bullet:[
            "Incorporación del protocolo de seguridad SSL para una conexión segura y cifrada.",
            "Todas las comunicaciones estarán cifradas de extremo a extremo para prevenir cualquier ataque.",
            "Sabrás cuáles son los dispositivos que se han conectado a tu red privada.",
            "Podrás autorizar qué dispositivos quieres que accedan a la red privada y cuáles no.",
            "Esta solución podrá estar disponible desde cualquier dispositivo móvil.",
            "La solución contará con una configuración inicial y con las respectivas actualizaciones de seguridad.",
          ],
        },
        dropTwo:[
          "La solución se dotará en dos fases.",
          "La primera, 3 meses con una ejecución comprometida del 70%.",
          "La segunda fase, 12 meses con una ejecución comprometida del 30%."
        ]
      },
      {
        title:"Ciberseguridad",
        icon:{
          src:"../../../assets/svg/Cybersecurity.svg",
          alt:"Cybersecurity_icon"
        },
        dropOne:{
          textArray:[
            "En esta categoría podrás canjear un importe máximo de 125€ por usuario. Si eres del segmento I podrás cajear hasta 48 usuarios, si eres del segmento II hasta 9 usuarios y si perteneces al segmento III solo podrás canjear hasta 2 usuarios.",
            "El objetivo es que todos los dispositivos de tus empleados tengan la seguridad requerida, los servicios y funcionalidades son los siguientes:",
          ],
          bullet:[
            "Herramienta antimalware para analizar tu dispositivo y archivos internos y externos.",
            "Herramienta para detectar y evitar un malware espía.",
            "Podrás analizar los correos que recibes a través de una solución antispam para filtrar los correos no deseados y antiphishing para aquellos correos que contienen malwares.",
            "Navegaras por internet de una forma segura.",
            "Conocerás en todo momento las nuevas amenazas y el comportamiento de las amenazas que ya existen.",
            "Contarás con las herramientas necesarias para monitorizar el tráfico de la red y para alertarte de amenazas.",
            "Se realizará una configuración inicial para que puedas utilizarla correctamente con sus respectivas actualizaciones.",
            "Este servicio también incluye una formación tutorizada para configurar el software de seguridad."
          ],
        },
        dropTwo:[
          "La solución se dotará en dos fases.",
          "La primera, 3 meses con una ejecución comprometida del 70%.",
          "La segunda fase, 12 meses con una ejecución comprometida del 30%."
        ]
      },
      
    ]

   }

  ngOnInit(): void {
  }
  
}
